import {Component, OnDestroy, OnInit} from '@angular/core';
import {VehicleInfoService} from './vehicle-info.service';
import {Subscription} from 'rxjs';
import {SelectItem} from 'primeng/api';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {AcceptTermsEuComponent} from './accept-terms-eu/accept-terms-eu.component';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-vehicle-eu-standard-info',
  templateUrl: './vehicle-eu-standard-info.component.html',
  styleUrls: ['./vehicle-eu-standard-info.component.scss']
})
export class VehicleEuStandardInfoComponent implements OnInit, OnDestroy {
  faFilter = faFilter;
  isSmallScreen = false;
  displayedColumns: string[] = ['ManufacturerName', 'ManufactureCountry', 'StandardizationType', 'Type', 'Variant'];
  dataSource: any[] = [];
  filteredData: any[] = [];
  variantOptions: SelectItem[] = [];
  typeOptions: SelectItem[] = [];
  countryOptions: SelectItem[] = [];

  selectedVariant: any = null;
  selectedType = null;
  selectedCountry = null;

  private subscription: Subscription; // Hold the subscription

  constructor(private vehicleInfoService: VehicleInfoService,
              private breakpointObserver: BreakpointObserver,
              private dialog: MatDialog,
              private router: Router,
  ) {
  }

  ngOnInit(): void {

    this.breakpointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe(result => {
      this.isSmallScreen = result.matches;
    });

    const approve = this.dialog.open(AcceptTermsEuComponent, {});
    approve.afterClosed().subscribe(res => {
      if (!res || !res.approve) {
        this.router.navigate(['/account']);
      } else {
        this.subscription = this.vehicleInfoService.getAll({}).subscribe((data: any) => {
          console.log(data);
          this.dataSource = data;
          this.filteredData = [...this.dataSource];

          // Populate the dropdown options
          const uniqueVariants = [...new Set(data.map(item => item.Variant))];
          this.variantOptions = uniqueVariants.map(variant => ({label: variant as string, value: variant as string}));
          this.typeOptions = [...new Set(data.map(item => item.Type))]
            .map(type => ({label: type as string, value: type as string}));
          this.countryOptions = [...new Set(data.map(item => item.ManufactureCountry))]
            .map(country => ({label: country as string, value: country as string}));


        });
      }


    });


  }


  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  applyFilter() {
    const lowercased = (value: string) => value?.toLowerCase() || '';
    const includes = (value: string, search: string) => !search || value?.toLowerCase().includes(search);

    const selectedVariant = lowercased(this.selectedVariant?.value);
    const selectedType = lowercased(this.selectedType?.value);
    const selectedCountry = lowercased(this.selectedCountry?.value);

    this.filteredData = this.dataSource.filter(item => {
      const variantMatch = includes(item.Variant, selectedVariant);
      const typeMatch = includes(item.Type, selectedType);
      const countryMatch = includes(item.ManufactureCountry, selectedCountry);
      return variantMatch && typeMatch && countryMatch;
    });
  }

  clearFilters(): void {
    this.selectedVariant = null;
    this.selectedType = null;
    this.selectedCountry = null;

    this.applyFilter();
  }

  clearVariantFilter(): void {
    this.selectedVariant = null;
    // this.applyFilter();
  }

  clearTypeFilter(): void {
    this.selectedType = null;
    // this.applyFilter();
  }

  clearCountryFilter(): void {
    this.selectedCountry = null;
    // this.applyFilter();
  }


  // applyFilter() {
  //     const selectedVariant = this.selectedVariant ? this.selectedVariant.value.toLowerCase() : '';
  //     const selectedType = this.selectedType ? this.selectedType.value.toLowerCase() : '';
  //     const selectedCountry = this.selectedCountry ? this.selectedCountry.value.toLowerCase() : '';
  //
  //     this.filteredData = this.dataSource.filter(item => {
  //         const variantMatch = (item.Variant || item.Variant === '' || item.Variant === null) ? item.Variant?.toLowerCase()?.includes(selectedVariant) : true;
  //         const typeMatch = item.Type ? item.Type.toLowerCase().includes(selectedType) : true;
  //         const countryMatch = item.ManufactureCountry ? item.ManufactureCountry.toLowerCase().includes(selectedCountry) : true;
  //         return variantMatch && typeMatch && countryMatch;
  //     });
  // }

}
